// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='RenameModal'] .error{\r\n        color: #DF2714;\r\n        font-family: Montserrat;\r\n        font-size: 16px;\r\n        line-height: 18px;\r\n        word-wrap: break-word;\r\n        width: 100%;\r\n        padding: .7em;\r\n    };", ""]);
// Exports
module.exports = exports;
